/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  FulfillmentPartnerStaffApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Retrieves all active fulfillment partners with their shipping options and excluded states.
 */
export const getFulfillmentpartners = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<FulfillmentPartnerStaffApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/fulfillmentpartners`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFulfillmentpartnersInfiniteQueryKey = () => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/fulfillmentpartners`
    ] as const;
    }

export const getGetFulfillmentpartnersQueryKey = () => {
    return [
    `https://providers-api.api.quick.md/api/v1/fulfillmentpartners`
    ] as const;
    }

    
export const getGetFulfillmentpartnersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getFulfillmentpartners>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFulfillmentpartnersInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFulfillmentpartners>>> = ({ signal }) => getFulfillmentpartners(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFulfillmentpartnersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getFulfillmentpartners>>>
export type GetFulfillmentpartnersInfiniteQueryError = void | ErrorApiOutContract


export function useGetFulfillmentpartnersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFulfillmentpartners>>,
          TError,
          Awaited<ReturnType<typeof getFulfillmentpartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFulfillmentpartnersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFulfillmentpartners>>,
          TError,
          Awaited<ReturnType<typeof getFulfillmentpartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFulfillmentpartnersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all active fulfillment partners with their shipping options and excluded states.
 */

export function useGetFulfillmentpartnersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFulfillmentpartnersInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all active fulfillment partners with their shipping options and excluded states.
 */
export const prefetchGetFulfillmentpartnersInfiniteQuery = async <TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetFulfillmentpartnersInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetFulfillmentpartnersQueryOptions = <TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFulfillmentpartnersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFulfillmentpartners>>> = ({ signal }) => getFulfillmentpartners(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFulfillmentpartnersQueryResult = NonNullable<Awaited<ReturnType<typeof getFulfillmentpartners>>>
export type GetFulfillmentpartnersQueryError = void | ErrorApiOutContract


export function useGetFulfillmentpartners<TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFulfillmentpartners>>,
          TError,
          Awaited<ReturnType<typeof getFulfillmentpartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFulfillmentpartners<TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFulfillmentpartners>>,
          TError,
          Awaited<ReturnType<typeof getFulfillmentpartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFulfillmentpartners<TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all active fulfillment partners with their shipping options and excluded states.
 */

export function useGetFulfillmentpartners<TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFulfillmentpartnersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all active fulfillment partners with their shipping options and excluded states.
 */
export const prefetchGetFulfillmentpartnersQuery = async <TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetFulfillmentpartnersQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetFulfillmentpartnersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFulfillmentpartnersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFulfillmentpartners>>> = ({ signal }) => getFulfillmentpartners(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFulfillmentpartnersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFulfillmentpartners>>>
export type GetFulfillmentpartnersSuspenseQueryError = void | ErrorApiOutContract


export function useGetFulfillmentpartnersSuspense<TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFulfillmentpartnersSuspense<TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFulfillmentpartnersSuspense<TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all active fulfillment partners with their shipping options and excluded states.
 */

export function useGetFulfillmentpartnersSuspense<TData = Awaited<ReturnType<typeof getFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFulfillmentpartnersSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFulfillmentpartnersSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getFulfillmentpartners>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFulfillmentpartnersInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFulfillmentpartners>>> = ({ signal }) => getFulfillmentpartners(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFulfillmentpartnersSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getFulfillmentpartners>>>
export type GetFulfillmentpartnersSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetFulfillmentpartnersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFulfillmentpartnersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFulfillmentpartnersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all active fulfillment partners with their shipping options and excluded states.
 */

export function useGetFulfillmentpartnersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFulfillmentpartnersSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




